/* eslint max-len: 0 */
import React, { FC } from 'react';
import { SvgComponentProps } from './types';
import { Svg } from './Svg';

const ModAssessment: FC<SvgComponentProps> = (props) => {
	return (
		<Svg {...props}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M9.38053 1.5051L8 0L6.61946 1.5051L4.74611 0.691637L4.0971 2.62813L2.05484 2.64696L2.24959 4.68L0.391546 5.52786L1.39637 7.30593L0.0438232 8.83623L1.68498 10.0519L1.0718 12L3.06552 12.443L3.29772 14.4721L5.29927 14.0659L6.33671 15.8252L8 14.64L9.66329 15.8252L10.7007 14.0659L12.7023 14.4721L12.9345 12.443L14.9282 12L14.315 10.0519L15.9562 8.83623L14.6036 7.30593L15.6084 5.52786L13.7504 4.68L13.9452 2.64696L11.9029 2.62813L11.2539 0.691637L9.38053 1.5051ZM4.75 6.44211L3 8.29474L6.66666 12L13 5.85263L11.25 4L6.75 8.46316L4.75 6.44211Z'
			/>
		</Svg>
	);
};

export { ModAssessment };
